import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, TextField } from "@mui/material";
import { announcementState } from "../../../atoms/announcement";
import { useRecoilState } from "recoil";
import { useState } from "react";

const Announcements = () => {
  const [announcement, setAnnouncement] = useRecoilState(announcementState);
  const [input, setInput] = useState('');

  const save = () => {
    setAnnouncement(input);
  }

  const handleChange = (text: string) => {
    setInput(text);
  }

  return (
    <>
      <div className="center">
        <h1>Announcements</h1>

        <Button
          id="save"
          variant="outlined"
          className="margin-bottom"
          startIcon={<FontAwesomeIcon icon={["fas", "floppy-disk-circle-arrow-right"]}/>}
          onClick={() => {
            save()
          }}>
            Save
        </Button>

        <TextField
          type="text"
          variant='outlined'
          color='secondary'
          label="Announcement"
          onChange={e => handleChange(e.target.value)}
          value={announcement ? announcement : input}
          sx={{width: 800}}
          fullWidth
          size="medium"
        />
      </div>
    </>
  );
}

export default Announcements